import React from "react";
import { SearchForm } from "../../components";

const SearchPage = ({}) => {
  return <SearchForm />;
};

SearchPage.propTypes = {};
SearchPage.defaultProps = {};

export default SearchPage;
